// @flow
import { FormattedCurrency } from "../../../../../../components/FormattedCurrency/FormattedCurrency";

export * from "../data";

export const currencyFormatter = (value: string | number) => (
  <FormattedCurrency
    value={value}
    minimumFractionDigits={2}
    maximumFractionDigits={2}
    currency="GBP"
  />
);

// Data hard coded for now. Should come from backend.
export const rows = [
  {
    location_html: <span>Durban, South Africa</span>,
    days_on_market: null,
    cost: 74285.75,
    rental: 445.13,
    airbnb: 4173.67,
  },
  {
    location_html: <span>Lagos, Nigeria</span>,
    days_on_market: null,
    cost: 104323.01,
    rental: 788.5,
    airbnb: 4732.2,
  },
  {
    location_html: <span>Cairo, Egypt</span>,
    days_on_market: null,
    cost: 47475.12,
    rental: 304.95,
    airbnb: 2066,
  },
  {
    location_html: (
      <span>
        Reykjavik, Iceland
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 329655.57,
    rental: 1734.46,
    airbnb: 10104.44,
  },
  {
    location_html: <span>Johannesburg, South Africa</span>,
    days_on_market: null,
    cost: 124701.01,
    rental: 691.73,
    airbnb: 3743.4,
  },
  {
    location_html: <span>Santiago, Chile</span>,
    days_on_market: null,
    cost: 147597.14,
    rental: 668.82,
    airbnb: 4343.8,
  },
  {
    location_html: <span>Athens, Greece</span>,
    days_on_market: null,
    cost: 163181.38,
    rental: 422.56,
    airbnb: 3865.4,
  },
  {
    location_html: <span>Bangalore, India</span>,
    days_on_market: null,
    cost: 89540.54,
    rental: 334.89,
    airbnb: 1965.8,
  },
  {
    location_html: <span>Dubai, UAE</span>,
    days_on_market: null,
    cost: 570876.18,
    rental: 3049.42,
    airbnb: 12513.2,
  },
  {
    location_html: <span>Bucharest, Romania</span>,
    days_on_market: null,
    cost: 132744.86,
    rental: 505.39,
    airbnb: 2891.6,
  },
  {
    location_html: <span>Medellin, Colombia</span>,
    days_on_market: null,
    cost: 138685.5,
    rental: 409.99,
    airbnb: 2804.8,
  },
  {
    location_html: <span>Cape Town, South Africa</span>,
    days_on_market: null,
    cost: 199429.04,
    rental: 972.01,
    airbnb: 3997.2,
  },
  {
    location_html: <span>Budapest, Hungary</span>,
    days_on_market: null,
    cost: 146638,
    rental: 603.99,
    airbnb: 2756,
  },
  {
    location_html: <span>Istanbul, Turkey</span>,
    days_on_market: null,
    cost: 173429.17,
    rental: 749.49,
    airbnb: 3086.2,
  },
  {
    location_html: <span>Washington D.C., USA</span>,
    days_on_market: null,
    cost: 628549.24,
    rental: 2872.55,
    airbnb: 9817.4,
  },
  {
    location_html: <span>Delhi, India</span>,
    days_on_market: null,
    cost: 139577.58,
    rental: 415.66,
    airbnb: 2138.4,
  },
  {
    location_html: <span>Dusseldorf, Germany</span>,
    days_on_market: null,
    cost: 470034.07,
    rental: 1267.98,
    airbnb: 6863.2,
  },
  {
    location_html: <span>Sofia, Bulgaria</span>,
    days_on_market: null,
    cost: 119286.6,
    rental: 494.86,
    airbnb: 1726.6,
  },
  {
    location_html: <span>Frankfurt am Main, Germany</span>,
    days_on_market: null,
    cost: 551986.5,
    rental: 1371.07,
    airbnb: 7758.4,
  },
  {
    location_html: <span>Montreal, Canada</span>,
    days_on_market: null,
    cost: 279032.17,
    rental: 1020.77,
    airbnb: 3792.4,
  },
  {
    location_html: <span>Bogota, Colombia</span>,
    days_on_market: null,
    cost: 184747.78,
    rental: 546.62,
    airbnb: 2455.6,
  },
  {
    location_html: <span>Buenos Aires, Argentina</span>,
    days_on_market: null,
    cost: 210852.84,
    rental: 755.86,
    airbnb: 2771.8,
  },
  {
    location_html: <span>Sydney, Australia</span>,
    days_on_market: null,
    cost: 798072.5,
    rental: 2529.89,
    airbnb: 9957.4,
  },
  {
    location_html: <span>Dublin, Ireland</span>,
    days_on_market: null,
    cost: 496196.52,
    rental: 1680.84,
    airbnb: 5922,
  },
  {
    location_html: <span>Perth, Australia</span>,
    days_on_market: null,
    cost: 442234.38,
    rental: 1548.33,
    airbnb: 5215.6,
  },
  {
    location_html: (
      <span>
        Hamburg, Germany
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 478808.84,
    rental: 1198.9,
    airbnb: 5623.6,
  },
  {
    location_html: <span>Jakarta, Indonesia</span>,
    days_on_market: null,
    cost: 159375.57,
    rental: 1028.22,
    airbnb: 1870,
  },
  {
    location_html: (
      <span>
        Amsterdam, Netherlands
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 651424.73,
    rental: 1954.4,
    airbnb: 7472.4,
  },
  {
    location_html: <span>Riga, Latvia</span>,
    days_on_market: null,
    cost: 165331.58,
    rental: 526.78,
    airbnb: 1835.8,
  },
  {
    location_html: <span>Munich, Germany</span>,
    days_on_market: null,
    cost: 698110,
    rental: 1525.57,
    airbnb: 7750.6,
  },
  {
    location_html: <span>Edinburgh, UK</span>,
    days_on_market: null,
    cost: 307153,
    rental: 1284.55,
    airbnb: 3307.8,
  },
  {
    location_html: <span>Sao Paulo, Brazil</span>,
    days_on_market: null,
    cost: 234261.37,
    rental: 838.92,
    airbnb: 2510.6,
  },
  {
    location_html: <span>Mexico City, Mexico</span>,
    days_on_market: null,
    cost: 187967.3,
    rental: 677.37,
    airbnb: 1953.2,
  },
  {
    location_html: <span>Prague, Czech Republic</span>,
    days_on_market: null,
    cost: 270986.2,
    rental: 829.01,
    airbnb: 2800,
  },
  {
    location_html: (
      <span>
        Barcelona, Spain
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 362206.7,
    rental: 1027.24,
    airbnb: 3662.6,
  },
  {
    location_html: <span>Warsaw, Poland</span>,
    days_on_market: null,
    cost: 207794.94,
    rental: 716.73,
    airbnb: 2096.6,
  },
  {
    location_html: <span>Brussels, Belgium</span>,
    days_on_market: null,
    cost: 296047.01,
    rental: 1185.33,
    airbnb: 2862.6,
  },
  {
    location_html: <span>Rio de Janeiro, Brazil</span>,
    days_on_market: null,
    cost: 290687.46,
    rental: 1024.2,
    airbnb: 2784.6,
  },
  {
    location_html: (
      <span>
        Berlin, Germany
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 395893.03,
    rental: 1080.83,
    airbnb: 3772.8,
  },
  {
    location_html: <span>Geneva, Switzerland</span>,
    days_on_market: null,
    cost: 1050703.06,
    rental: 2666.26,
    airbnb: 9858.4,
  },
  {
    location_html: <span>Auckland, New Zealand</span>,
    days_on_market: null,
    cost: 617061.72,
    rental: 1623.59,
    airbnb: 5710.4,
  },
  {
    location_html: <span>Copenhagen, Denmark</span>,
    days_on_market: null,
    cost: 535486.99,
    rental: 2039.8,
    airbnb: 4780.6,
  },
  {
    location_html: <span>Melbourne, Australia</span>,
    days_on_market: null,
    cost: 548137.27,
    rental: 1818.12,
    airbnb: 4695,
  },
  {
    location_html: <span>Kuala Lumpur, Malaysia</span>,
    days_on_market: null,
    cost: 154223.73,
    rental: 709.04,
    airbnb: 1310.4,
  },
  {
    location_html: <span>Zurich, Switzerland</span>,
    days_on_market: null,
    cost: 1062435.66,
    rental: 2518.64,
    airbnb: 8760.4,
  },
  {
    location_html: <span>Los Angeles, USA</span>,
    days_on_market: null,
    cost: 687679,
    rental: 2474.6,
    airbnb: 5619.8,
  },
  {
    location_html: <span>Stockholm, Sweden</span>,
    days_on_market: null,
    cost: 734786.54,
    rental: 1727.82,
    airbnb: 5923,
  },
  {
    location_html: <span>Hanoi, Vietnam</span>,
    days_on_market: null,
    cost: 210734.85,
    rental: 667.41,
    airbnb: 1674,
  },
  {
    location_html: <span>Chicago, USA</span>,
    days_on_market: null,
    cost: 371230,
    rental: 2151.92,
    airbnb: 2943.8,
  },
  {
    location_html: <span>Osaka, Japan</span>,
    days_on_market: null,
    cost: 370273.65,
    rental: 1029.06,
    airbnb: 2925.8,
  },
  {
    location_html: <span>Oslo, Norway</span>,
    days_on_market: null,
    cost: 582987.33,
    rental: 1738.68,
    airbnb: 4549,
  },
  {
    location_html: <span>Toronto, Canada</span>,
    days_on_market: null,
    cost: 484832.35,
    rental: 1632.09,
    airbnb: 3603.8,
  },
  {
    location_html: <span>Miami, USA</span>,
    days_on_market: null,
    cost: 766059.47,
    rental: 2452.5,
    airbnb: 5594.4,
  },
  {
    location_html: <span>Madrid, Spain</span>,
    days_on_market: null,
    cost: 467941.67,
    rental: 1203.9,
    airbnb: 3381.8,
  },
  {
    location_html: <span>Bangkok, Thailand</span>,
    days_on_market: null,
    cost: 287883.28,
    rental: 982.48,
    airbnb: 2039,
  },
  {
    location_html: <span>Vienna, Austria</span>,
    days_on_market: null,
    cost: 506144.8,
    rental: 1188.18,
    airbnb: 3509.6,
  },
  {
    location_html: <span>Brisbane, Australia</span>,
    days_on_market: null,
    cost: 422703.56,
    rental: 1611.72,
    airbnb: 2857,
  },
  {
    location_html: <span>Lisbon, Portugal</span>,
    days_on_market: null,
    cost: 386316.36,
    rental: 895.03,
    airbnb: 2604.2,
  },
  {
    location_html: <span>Tel Aviv, Israel</span>,
    days_on_market: null,
    cost: 916620.84,
    rental: 1450.82,
    airbnb: 5804.8,
  },
  {
    location_html: <span>Helsinki, Finland</span>,
    days_on_market: null,
    cost: 604542.61,
    rental: 1592.13,
    airbnb: 3459.8,
  },
  {
    location_html: <span>Milan, Italy</span>,
    days_on_market: null,
    cost: 742942.86,
    rental: 1500.48,
    airbnb: 4251.2,
  },
  {
    location_html: <span>Singapore, Singapore</span>,
    days_on_market: null,
    cost: 1170818.58,
    rental: 2883.96,
    airbnb: 6589.4,
  },
  {
    location_html: <span>Moscow, Russia</span>,
    days_on_market: null,
    cost: 503420.29,
    rental: 1159.79,
    airbnb: 2832.8,
  },
  {
    location_html: (
      <span>
        New York City, USA
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 1299687.14,
    rental: 4103.32,
    airbnb: 7174.8,
  },
  {
    location_html: (
      <span>
        London, UK
        <sup>6</sup>
      </span>
    ),
    days_on_market: null,
    cost: 1692859.78,
    rental: 4221.91,
    airbnb: 8814.33,
  },
  {
    location_html: (
      <span>
        San Francisco, USA
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 1123089,
    rental: 4281.27,
    airbnb: 5509.4,
  },
  {
    location_html: <span>Shanghai, China</span>,
    days_on_market: null,
    cost: 885875.71,
    rental: 1517.35,
    airbnb: 4308.2,
  },
  {
    location_html: <span>Vancouver, Canada</span>,
    days_on_market: null,
    cost: 681373.11,
    rental: 2000.16,
    airbnb: 3178.4,
  },
  {
    location_html: (
      <span>
        Paris, France
        <sup>5</sup>
      </span>
    ),
    days_on_market: null,
    cost: 958088.48,
    rental: 1893.48,
    airbnb: 4436.6,
  },
  {
    location_html: <span>Rome, Italy</span>,
    days_on_market: null,
    cost: 780296.49,
    rental: 1454.38,
    airbnb: 3573,
  },
  {
    location_html: <span>Seoul, South Korea</span>,
    days_on_market: null,
    cost: 831768.32,
    rental: 1635.83,
    airbnb: 3628,
  },
  {
    location_html: <span>Tokyo, Japan</span>,
    days_on_market: null,
    cost: 1214172.5,
    rental: 2019.6,
    airbnb: 4605.4,
  },
  {
    location_html: <span>Taipei, Taiwan</span>,
    days_on_market: null,
    cost: 822781.88,
    rental: 1187.71,
    airbnb: 3035.2,
  },
  {
    location_html: <span>Hong Kong, Hong Kong</span>,
    days_on_market: null,
    cost: 1893534.94,
    rental: 3313.57,
    airbnb: 4152.4,
  },
  {
    location_html: <span>Beijing, China</span>,
    days_on_market: null,
    cost: 1059002.81,
    rental: 1579.64,
    airbnb: 1482.8,
  },
];
